
<ul style="list-style: none;">
  <li *ngFor="let subtopic of topic.subtopics;">

          <div *ngIf ="subtopic.is_open==1">

              <!--input  *ngIf="subtopic.isSelected" type="checkbox" name="subtopic" value="{{subtopic.id}}" checked  (change)="updateSelection(subtopic)"/-->
              <!--input  *ngIf="!subtopic.isSelected" type="checkbox" name="subtopic" value="{{subtopic.id}}" (change)="updateSelection(subtopic)"/-->
            <input *ngIf="subtopic.questionTemplateCount>0" type="checkbox" name="subtopic" value="{{subtopic.id}}" (change)="updateSelection(subtopic)"/>
            <span *ngIf="subtopic.questionTemplateCount==0" ><i class="fa fa-square  text-secondary"></i></span>
           {{subtopic.name}}
          </div>
          <div *ngIf ="subtopic.is_open==0" (click)="alertNeedToRegister(subtopic.name)">
             <i class="fa fa-square text-primary"></i> <span class="text-warning"> (premium)</span> {{subtopic.name}}
          </div>

  </li>

</ul>

